// @flow

import React from "react";
import { localize } from "redux-i18n";
import { SimpleGrid, WistiaPlayer } from "@components";

type Props = PropsFromLocalize;

class HelpPanelUserAccount extends React.Component<Props> {
  get accountDetailsData() {
    return [
      {
        id: "date-registered",
        label: this.props.t("DATE_REGISTERED"),
        details: this.props.t("USER_ACCOUNT_DATE_REGISTERED_DESCRIPTION"),
      },
      {
        id: "account-status",
        label: this.props.t("ACCOUNT_STATUS"),
        details: this.props.t("USER_ACCOUNT_STATUS_DESCRIPTION", {
          enabled: <span className="font-weight-bold">{this.props.t("ENABLED")}</span>,
          disabled: <span className="font-weight-bold">{this.props.t("DISABLED")}</span>,
        }),
      },
      {
        id: "user-status",
        label: this.props.t("USER_STATUS"),
        details: this.props.t("USER_ACCOUNT_USER_STATUS_DESCRIPTION", {
          locked: <span className="font-weight-bold">{this.props.t("LOCKED")}</span>,
          unlocked: <span className="font-weight-bold">{this.props.t("UNLOCKED")}</span>,
        }),
      },
      {
        id: "lock-unlock",
        label: this.props.t("LOCK_UNLOCK_BUTTON"),
        details: this.props.t("USER_ACCOUNT_LOCK_UNLOCK_DESCRIPTION"),
      },
    ];
  }

  get accessLevelData() {
    return [
      {
        id: "user-type",
        label: this.props.t("USER_TYPE"),
        details: this.props.t("USER_TYPE_DESCIPTION"),
      },
      {
        id: "data-exposure-index",
        label: this.props.t("DATA_EXPOSURE_TITLE"),
        details: this.props.t("USER_DATA_EXPOSURE_INDEX_DESCRIPTION"),
      },
    ];
  }

  get areaOfAccessData() {
    return [
      {
        id: "access-area",
        label: this.props.t("AREA_OF_ACCESS"),
        details: this.props.t("USER_AREA_OF_ACCESS_DESCRIPTION"),
      },
      {
        id: "areas-included",
        label: this.props.t("AREAS_INCLUDED"),
        details: this.props.t("USER_AREAS_INCLUDED_DESCRIPTION"),
      },
      {
        id: "areas-excluded",
        label: this.props.t("AREAS_EXCLUDED"),
        details: this.props.t("USER_AREAS_EXCLUDED_DESCRIPTION"),
      },
    ];
  }

  get adminActionsData() {
    return [
      {
        id: "password-reset",
        label: this.props.t("PASSWORD_RESET"),
        details: this.props.t("USER_PASSWORD_RESET_DESCRIPTION"),
      },
      {
        id: "impersonate",
        label: this.props.t("IMPERSONATE"),
        details: this.props.t("USER_IMPERSONATE_DESCRIPTION"),
      },
      {
        id: "change-password",
        label: this.props.t("CHANGE_PASSWORD"),
        details: this.props.t("USER_CHANGE_PASSWORD_DESCRIPTION"),
      },
    ];
  }

  get userTypeData() {
    return [
      {
        id: "employee",
        label: this.props.t("EMPLOYEE"),
        details: this.props.t("EMPLOYEE_DESCRIPTION"),
      },
      {
        id: "manager",
        label: this.props.t("MANAGER"),
        details: this.props.t("MANAGER_DESCRIPTION"),
      },
      {
        id: "advanced-user",
        label: this.props.t("ADVANCED_USER"),
        details: this.props.t("ADVANCED_USER_DESCRIPTION"),
      },
      {
        id: "full-access",
        label: this.props.t("FULL_ACCESS"),
        details: this.props.t("FULL_ACCESS_DESCRIPTION"),
      },
      {
        id: "client-admin",
        label: this.props.t("CLIENT_ADMIN"),
        details: this.props.t("CLIENT_ADMIN_USER_DESCRIPTION"),
      },
      {
        id: "trend-viewer",
        label: this.props.t("CLIENT_TREND_VIEWER"),
        details: this.props.t("TREND_VIEWER_DESCRIPTION"),
      },
      {
        id: "data-transfer",
        label: this.props.t("DATA_TRANSFER"),
        details: this.props.t("DATA_TRANSFER_DESCRIPTION"),
      },
    ];
  }

  get columns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  render() {
    return (
      <div>
        <p className="fs-14">{this.props.t("USER_ACCOUNT_INTRODUCTION")}</p>
        <h6 className="font-weight-bold">{this.props.t("TUTORIAL")}</h6>
        <div className="mb-3">
          <WistiaPlayer
            videoId={WistiaPlayer.videos.ACCOUNT_INSTRUCTIONS}
            title={this.props.t("ACCOUNT_INSTRUCTIONS")}
          />
        </div>
        <h6 className="font-weight-bold">{this.props.t("ACCOUNT_DETAILS")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.accountDetailsData} />
        <h6 className="font-weight-bold">{this.props.t("ACCESS_LEVEL")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.accessLevelData} />
        <h6 className="font-weight-bold">{this.props.t("AREA_OF_ACCESS")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.areaOfAccessData} />
        <h6 className="font-weight-bold">{this.props.t("ADMIN_ACTIONS")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.adminActionsData} />
        <h6 className="font-weight-bold">{this.props.t("USER_TYPES")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.userTypeData} />
      </div>
    );
  }
}

export default localize()(HelpPanelUserAccount);
